export const MODE_ENUM = {
  streaming: "streaming",
  picture: "picture",
  snapshot: "snapshot",
  livePhoto: "live-photo",
  clipStreaming: "clip-streaming",
  playback: "playback",
};

export const SIM_PROVIDER_NAME_ENUM = {
  usc: "USC",
  usCellular: "US Cellular",
};

export const STATUS_ENUM = {
  live: 'live',
  mp4Uploaded: "mp4Uploaded",
  uploading: 'uploading',
  waitForPublish: 'waitForPublish',
  waitForAwake: 'waitForAwake',
  waitForStop: 'waitForStop',
  stopped: 'stopped',
  timeout: 'timeout',
  offline: 'offline',
  firmwareNotSupport: 'firmwareNotSupport',
  failed: 'failed'
}

export const ACTION_ENUM = {
  start: 'start',
  stop: 'stop'
}

export const ROTATE_ENUM = {
  upsidedown: 'upsidedown'
}

export const MANUFACTURER_ENUM = {
  vidFleet: 'VidFleet',
  smartWitness: 'SmartWitness',
  lightMetrics: 'LightMetrics',
}

export const DEVICE_MODEL_ENUM = {
  device360: '360',
  device4k: '4K',
}

export const THUMBNAILURL_SMARTWITNESS = "/SmartWitness/";

export const MAX_ATTEMPTS = 30;